export interface SideBar {
  text: string
  imgCode: string
  id: string
  imgOnly: boolean
  fontAwesome: boolean
  listType: string
  subMenu: SubMenu[]
}

export interface SubMenu {
  text: string
  imgCode: string
  fontAwesome: boolean
  webCode?: string
  imagePart?: string
  childSubMenu?: ChildSubMenu[]
  hasEdge?: boolean
  hasPortal?: boolean
  hasChannel?: boolean
  hasExChannel?: boolean

}

export interface ChildSubMenu {
  text: string
  sideImg?: string
  mainImg?: string
  imagePart?: string
  webCode: string
}

const data: SideBar[] = [
  {
    "text": "",
    "imgCode": "Main_Icons/Outline_logo.png",
    "id": "block-1",
    "imgOnly": true,
    "fontAwesome": false,
    "listType": "",
    "subMenu": []
  },
  {
    "text": "Door Range",
    "imgCode": "Main_Icons/Door_Range_Icon.png",
    "id": "block-2",
    "imgOnly": false,
    "fontAwesome": false,
    "listType": "large",
    "subMenu": [
      {
        "text": "Porter",
        "imgCode": "Door_Range/Porter",
        "imagePart": "Porter",
        "fontAwesome": false,
        "webCode": "cr1",
        "hasEdge": true,
        "hasPortal": true,
        "hasChannel": true,
        "hasExChannel": true,
      },
      {
        "text": "Hunton",
        "imgCode": "Door_Range/Hunton",
        "imagePart": "Hunton",
        "fontAwesome": false,
        "webCode": "cr2",
        "hasEdge": true,
      },
      {
        "text": "Fitzroy",
        "imgCode": "Door_Range/Fitzroy",
        "imagePart": "Fitzroy",
        "fontAwesome": false,
        "webCode": "cr3",
        "hasEdge": true,
        "hasPortal": true
      },
      {
        "text": "Mornington Shaker",
        "imgCode": "Door_Range/Mornington_Shaker",
        "imagePart": "Mornington_Shaker",
        "fontAwesome": false,
        "webCode": "cr4",
        "hasEdge": true,
      },
      {
        "text": "Mornington Beaded",
        "imgCode": "Door_Range/Mornington_Beaded",
        "imagePart": "Mornington_Beaded",
        "fontAwesome": false,
        "webCode": "cr5",
        "hasEdge": true,
      },
      {
        "text": "Crathorne",
        "imgCode": "Door_Range/Crathorne",
        "imagePart": "Crathorne",
        "fontAwesome": false,
        "webCode": "cr6",
        "hasEdge": true,
      }
    ]
  },
  {
    "text": "Edit",
    "imgCode": "Main_Icons/Edit_Icon.png",
    "id": "block-3",
    "imgOnly": false,
    "fontAwesome": false,
    "listType": "medium",
    "subMenu": [
      {
        "text": "Door Colour",
        "imgCode": "Edit/Colour/Neutrals/White",
        "fontAwesome": false,
        "childSubMenu": [

          //White Collection
          {
              "text": "White",
              "imagePart": "White",
              "webCode": "cc1",
          },
          {
              "text": "Chalk",
              "imagePart": "Chalk",
              "webCode": "cc2",
          },
          {
              "text": "Porcelain",
              "imagePart": "Porcelain",
              "webCode": "cc3",
          },

          //Neutral Collection - Light
          {
              "text": "Mussel",
              "imagePart": "Mussel",
              "webCode": "cc4",
          },
          {
              "text": "Meadowell",
              "imagePart": "Meadowell",
              "webCode": "cc5",
          },

          //Neutral Collection - Mid-Tone
          {
              "text": "Taupe Grey",
              "imagePart": "Taupe_Grey",
              "webCode": "cc6",
          },
          {
              "text": "Cashmere",
              "imagePart": "Cashmere",
              "webCode": "cc7",
          },
          {
              "text": "Stone",
              "imagePart": "Stone",
              "webCode": "cc8",
          },

          //Neutral Collection - Deep
          {
              "text": "Putty",
              "imagePart": "Putty",
              "webCode": "cc9",
          },
          {
              "text": "Fawn",
              "imagePart": "Fawn",
              "webCode": "cc10",
          },
          {
              "text": "Truffle",
              "imagePart": "Truffle",
              "webCode": "cc11",
          },

          //Red Collection 
          {
              "text": "Dry Rose",
              "imagePart": "Dry_Rose",
              "webCode": "cc12",
          },
          //{
          //    "text": "Georgian Red",
          //    "imagePart": "Georgian_Red",
          //    "webCode": "cc13",
          //},
          {
              "text": "Malbec",
              "imagePart": "Malbec",
              "webCode": "cc14",
          },

          //Grey Collection - Cool
          {
              "text": "Dove Grey",
              "imagePart": "Dove_Grey",
              "webCode": "cc15",
          },
          {
              "text": "Partridge Grey",
              "imagePart": "Partridge_Grey",
              "webCode": "cc16",
          },
          {
              "text": "Silver Grey",
              "imagePart": "Silver_Grey",
              "webCode": "cc17",
          },
          {
              "text": "Dust Grey",
              "imagePart": "Dust_Grey",
              "webCode": "cc18",
          },

          //Grey Collection - Solace
          {
              "text": "Slate",
              "imagePart": "Slate",
              "webCode": "cc19",
          },
          {
              "text": "Graphite",
              "imagePart": "Graphite",
              "webCode": "cc20",
          },
          {
              "text": "Carbon",
              "imagePart": "Carbon",
              "webCode": "cc21",
          },

          //Blue Collection - Pastel
          {
              "text": "Ives Blue",
              "imagePart": "Ives_Blue",
              "webCode": "cc22",
          },
          {
              "text": "Cadet",
              "imagePart": "Cadet",
              "webCode": "cc23",
          },

          //Blue Collection - Dusky
          {
              "text": "Storm Blue",
              "imagePart": "Storm_Blue",
              "webCode": "cc24",
          },
          {
              "text": "Charcoal",
              "imagePart": "Charcoal",
              "webCode": "cc25",
          },

          //Blue Collection - Ink
          {
              "text": "Hartforth Blue",
              "imagePart": "Hartforth_Blue",
              "webCode": "cc26",
          },
          {
              "text": "Majestic Teal",
              "imagePart": "Majestic_Teal",
              "webCode": "cc27",
          },
          //{
          //    "text": "Inkwell",
          //    "imagePart": "Inkwell",
          //    "webCode": "cc28",
          //},

          //Green Collection - Blue
          {
              "text": "China Blue",
              "imagePart": "China_Blue",
              "webCode": "cc29",
          },
          {
              "text": "Seaglass",
              "imagePart": "Seaglass",
              "webCode": "cc30",
          },
          {
              "text": "Chalk Blue",
              "imagePart": "Chalk_Blue",
              "webCode": "cc31",
          },

          //Green Collection - Olive
          {
              "text": "Sage",
              "imagePart": "Sage",
              "webCode": "cc32",
          },
          {
              "text": "Olive",
              "imagePart": "Olive",
              "webCode": "cc33",
          },
          //{
          //    "text": "Bay Green",
          //    "sideImg": "Edit/Colour/Greens/Bay_Green",
          //    "imagePart": "Bay_Green",
          //    "webCode": "cc34",
          //},

          //Green Collection - Forest
          {
              "text": "Regiment",
              "imagePart": "Regiment",
              "webCode": "cc35",
          },
          {
              "text": "Regents Green",
              "imagePart": "Regents_Green",
              "webCode": "cc36",
          },
          {
              "text": "Copse Green",
              "imagePart": "Copse_Green",
              "webCode": "cc37",
          },
        ]
      },
      {
        "text": "Handle Shape",
        "imgCode": "Edit/Handle_Shape/Portal",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "Edge",
            "imagePart": "Edge",
            "webCode": "hs1",
          },
          {
            "text": "Portal",
            "imagePart": "Portal",
            "webCode": "hs2",
          },
          {
            "text": "Channel",
            "imagePart": "Channel",
            "webCode": "hs3",
          },
          {
            "text": "Extended Channel",
            "imagePart": "Extended_Channel",
            "webCode": "hs4",
          },
        ]
      },
      {
        "text": "Backplate Finish",
        "imgCode": "Edit/Backplate_Finish/Aged_Brass",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "Carbon",
            "imagePart": "Carbon",
            "webCode": "bp1",
          },
          {
            "text": "Oak",
            "imagePart": "Oak",
            "webCode": "bp2",
          },
          {
            "text": "Walnut",
            "imagePart": "Walnut",
            "webCode": "bp3",
          },
          {
            "text": "Aged Brass",
            "imagePart": "Aged_Brass",
            "webCode": "bp4",
          },
          {
            "text": "Brushed Brass",
            "imagePart": "Brushed_Brass",
            "webCode": "bp6",
          },
          {
            "text": "Antique Bronze",
            "imagePart": "Antique_Bronze",
            "webCode": "bp7",
          },
          {
            "text": "Bright Copper",
            "imagePart": "Bright_Copper",
            "webCode": "bp8",
          },
          {
            "text": "Stainless Steel",
            "imagePart": "Stainless_Steel",
            "webCode": "bp5",
          },
        ]
      },
      {
        "text": "Worksurface",
        "imgCode": "Absolute_Marbled",
        "fontAwesome": false,
        "childSubMenu": [
          {
            "text": "Absolute Marbled",
            "mainImg": "Absolute_Marbled",
            "webCode": "ws1",
          },
          {
            "text": "Arabescato Corchia",
            "mainImg": "Arabescato_Corchia",
            "webCode": "ws2",
          },
          //{
          //  "text": "Arabieto Bianco",
          //  "mainImg": "Arabieto_Bianco",
          //  "webCode": "ws3",
          //},
          //{
          //  "text": "Arabieto Noir",
          //  "mainImg": "Arabieto_Noir",
          //  "webCode": "ws4",
          //},
          {
            "text": "Arctic Storm",
            "mainImg": "Arctic_Storm",
            "webCode": "ws5",
          },
          {
            "text": "Breccia Escuro",
            "mainImg": "Breccia_Escuro",
            "webCode": "ws6",
          },
          {
            "text": "Brilliant White",
            "mainImg": "Brilliant_White",
            "webCode": "ws7",
          },
          {
            "text": "Calacatta Gold",
            "mainImg": "Calacatta_Gold",
            "webCode": "ws8",
          },
          {
            "text": "Calacatta Platinum",
            "mainImg": "Calacatta_Platinum",
            "webCode": "ws9",
          },
          {
            "text": "Calacatta Silver",
            "mainImg": "Calacatta_Silver",
            "webCode": "ws10",
          },
          {
            "text": "Carrara Gioia",
            "mainImg": "Carrara_Gioia",
            "webCode": "ws11",
          },
          {
            "text": "Elegant Cream",
            "mainImg": "Elegant_Cream",
            "webCode": "ws12",
          },
          {
            "text": "Ferro Corchia",
            "mainImg": "Ferro_Corchia",
            "webCode": "ws13",
          },
          {
            "text": "Gold Antico",
            "mainImg": "Gold_Antico",
            "webCode": "ws14",
          },
          {
            "text": "Grafite Corchia",
            "mainImg": "Grafite_Corchia",
            "webCode": "ws15",
          },
          {
            "text": "Grigio Corchia",
            "mainImg": "Grigio_Corchia",
            "webCode": "ws16",
          },
          {
            "text": "Hail Storm",
            "mainImg": "Hail_Storm",
            "webCode": "ws17",
          },
          {
            "text": "Imperial",
            "mainImg": "Imperial",
            "webCode": "ws18",
          },
          {
            "text": "Macaubas Bianco",
            "mainImg": "Macaubas_Bianco",
            "webCode": "ws19",
          },
          {
            "text": "Marbled White",
            "mainImg": "Marbled_White",
            "webCode": "ws20",
          },
          {
            "text": "Mayville Concrete",
            "mainImg": "Mayville_Concrete",
            "webCode": "ws21",
          },
          {
            "text": "Morning Frost",
            "mainImg": "Morning_Frost",
            "webCode": "ws22",
          },
          {
            "text": "Nera Astratto",
            "mainImg": "Nera_Astratto",
            "webCode": "ws23",
          },
          {
            "text": "Patagonia",
            "mainImg": "Patagonia",
            "webCode": "ws24",
          },
          {
            "text": "Perlatino Polished",
            "mainImg": "Perlatino_Polished",
            "webCode": "ws25",
          },
          {
            "text": "Pietra Carbon",
            "mainImg": "Pietra_Carbon",
            "webCode": "ws26",
          },
          //{
          //  "text": "Pietra Charcoal",
          //  "mainImg": "Pietra_Charcoal",
          //  "webCode": "ws27",
          //},
          {
            "text": "Pietra Cloud",
            "mainImg": "Pietra_Cloud",
            "webCode": "ws28",
          },
          //{
          //  "text": "Pietra Silver",
          //  "mainImg": "Pietra_Silver",
          //  "webCode": "ws29",
          //},
          {
            "text": "Pietra Verde",
            "mainImg": "Pietra_Verde",
            "webCode": "ws30",
          },
          {
            "text": "Rosa Astratto",
            "mainImg": "Rosa_Astratto",
            "webCode": "ws31",
          },
          {
            "text": "Trinity Concrete",
            "mainImg": "Trinity_Concrete",
            "webCode": "ws32",
          },
          {
            "text": "Verde Calacatta",
            "mainImg": "Verde_Calacatta",
            "webCode": "ws33",
          },
          {
            "text": "White Dolomite",
            "mainImg": "White_Dolomite",
            "webCode": "ws34",
          },

        ]
      }
    ]
  },
  {
    "text": "Export",
    "imgCode": "Main_Icons/Export_Icon.png",
    "id": "block-4",
    "imgOnly": false,
    "fontAwesome": false,
    "listType": "small",
    "subMenu": [
      {
        "text": "Download Image",
        "imgCode": "far fa-image fa-lg fa-fw",
        "fontAwesome": true
      },
    ]
  },
 

];

export default data;